import { toMoment } from '@fortress-technology-solutions/fortress-component-library/utils';
import { validateName, validatePhoneNumber } from '../../../utils/validations';

// The checks the legacy form runs on the employers when saving progress. None of them requires a
// value, so a partly filled form can still be saved.

const INVALID = 'Invalid value';
const MUST_BE_AFTER_FROM = 'Must be after the From date';

const isBlank = (value) =>
  value === undefined || value === null || value === '';

export const nameRules = {
  validate: (value) => validateName(value) || INVALID,
};

export const phoneRules = {
  validate: (value) => validatePhoneNumber(value) || INVALID,
};

export const salaryRules = {
  validate: (value) => isBlank(value) || Number(value) >= 0 || INVALID,
};

export const dateRules = {
  validate: (value) =>
    isBlank(value) || Boolean(toMoment(value)?.isValid()) || INVALID,
};

export const endDateRules = (startName) => ({
  validate: (value, getValues) => {
    if (isBlank(value)) return true;
    const end = toMoment(value);
    if (!end?.isValid()) return INVALID;
    const start = toMoment(getValues(startName));
    return !start?.isValid() || !end.isBefore(start) || MUST_BE_AFTER_FROM;
  },
});
